// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3GyjY","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3u73s","obliqueLine":"membershipbadge_obliqueLine__2urFy"};